import axios from "axios";

console.log("🚀 [SYSTEM] LARK SERVICE V2 — CLOUD FUNCTION MODE");

// 🆔 EXACT LARK TABLE IDs (Your Lark Base)
export let LARK_TABLES = {
  QUESTIONS: "tblGNzStpur6kEPs",
  INTERVIEWS: "tbl6alIvvgsdQHXV",
  POSITIONS: "tblTmsaX5UPfugnW",
  LIVE_SESSIONS: "tbl8svC4LcjP9CTP",
  CANDIDATE_INFO: "tblecSQNpfPr46TX",
  ADMINS: "tblRt9QQ7SMpaRn0",
  // Backwards-compat aliases
  get LIVE_MONITOR() { return this.LIVE_SESSIONS; }
};

/**
 * 🚀 Call Lark via YOUR OWN Firebase Cloud Function
 *    No CORS issues. No bridges. No hacks.
 *    Your server → Lark server. Direct. Instant.
 */
export async function callLarkProxy(method, path, data = null) {
  try {
    console.log(`📡 [SERVER] ${method} ${path}`);
    const proxyUrl = window.location.hostname === "localhost" ? "http://localhost:4000/proxy" : "https://virtual-hr-el1.pages.dev/api/proxy";
    const response = await axios.post(proxyUrl, {
      method: method,
      path: path,
      data: data
    });
    return response.data;
  } catch (error) {
    console.error("❌ [SERVER] Error:", error.response?.data || error.message);
    throw error;
  }
}

// ─── Helper Exports ───

export const fetchQuestions = async () => {
  const res = await callLarkProxy("GET", `/tables/${LARK_TABLES.QUESTIONS}/records?page_size=500`);
  return res.data?.items?.map(i => ({ 
    id: i.record_id, 
    question: i.fields["Question"] || i.fields["question"] || "",
    category: i.fields["Category"] || i.fields["category"] || "General",
    difficulty: i.fields["Difficulty"] || i.fields["difficulty"] || "Easy",
    ...i.fields 
  })) || [];
};

export const fetchPositions = async () => {
  const res = await callLarkProxy("GET", `/tables/${LARK_TABLES.POSITIONS}/records?page_size=500`);
  return res.data?.items?.map(i => ({ 
    id: i.record_id, 
    title: i.fields["Title"] || i.fields["title"] || "",
    jobDescription: i.fields["Job Description"] || i.fields["jobDescription"] || "",
    ...i.fields 
  })) || [];
};

export const fetchInterviews = async () => {
  const res = await callLarkProxy("GET", `/tables/${LARK_TABLES.INTERVIEWS}/records?page_size=500`);
  return res.data?.items?.map(i => ({ 
    id: i.record_id, 
    candidateName: i.fields["Candidate Name"] || i.fields["candidateName"],
    userId: i.fields["User ID"] || i.fields["userId"],
    positionTitle: i.fields["Position Title"] || i.fields["positionTitle"],
    resumeScore: i.fields["Resume Score"] || i.fields["resumeScore"],
    interviewScore: i.fields["Interview Score"] || i.fields["interviewScore"],
    finalScore: i.fields["Final Score"] || i.fields["finalScore"],
    status: i.fields["Status"] || i.fields["status"],
    completedAt: i.fields["Completed At"] || i.fields["completedAt"],
    ...i.fields 
  })) || [];
};

export const createRecord = async (tableId, fields) => {
  const res = await callLarkProxy("POST", `/tables/${tableId}/records`, { fields });
  return res.data?.record?.record_id;
};

export const updateRecord = async (tableId, recordId, fields) => {
  // Lark Bitable's single-record update endpoint is PUT, not PATCH.
  // PATCH returns a 404 "page not found" (routing error), which broke EVERY
  // save — interview scores, status, and the video URL all silently failed.
  await callLarkProxy("PUT", `/tables/${tableId}/records/${recordId}`, { fields });
};

export const deleteRecord = async (tableId, recordId) => {
  await callLarkProxy("DELETE", `/tables/${tableId}/records/${recordId}`);
};

export const searchRecords = async (tableId, query) => {
  const res = await callLarkProxy("POST", `/tables/${tableId}/records/search`, { filter: query });
  return res.data?.items?.map(i => ({ id: i.record_id, ...i.fields })) || [];
};

export const createLiveSession = async (data) => {
  return await createRecord(LARK_TABLES.LIVE_SESSIONS, {
    "User ID": data.userId,
    "Candidate Name": data.candidateName,
    "Status": data.status,
    "Current Question": data.currentQuestion,
    "Total Questions": data.totalQuestions,
    "Cheating Flags": data.cheatingFlags,
    "Started At": Date.now()
  });
};

export const updateLiveSession = async (recordId, data) => {
  await updateRecord(LARK_TABLES.LIVE_SESSIONS, recordId, data);
};

export const saveInterview = async (data) => {
  return await createRecord(LARK_TABLES.INTERVIEWS, {
    "User ID": data["User ID"] || data.userId,
    "Candidate Name": data["Candidate Name"] || data.candidateName,
    "Position Title": data["Position Title"] || data.positionTitle,
    "Interview Score": data["Interview Score"] || data.interviewScore,
    "Final Score": data["Final Score"] || data.finalScore,
    "Answers JSON": data["Answers JSON"] || JSON.stringify(data.answers || []),
    "Resume Score": data["Resume Score"] || data.resumeScore || 0,
    "Resume URL": data["Resume URL"] || data.resumeUrl || "",
    "Status": data["Status"] || data.status || "active",
    "Completed At": Date.now()
  });
};

export const updateInterview = async (recordId, data) => {
  await updateRecord(LARK_TABLES.INTERVIEWS, recordId, data);
};

// Compatibility stubs — no longer needed with server-side proxy
export const discoverBase = async () => true;
export const discoverTables = async () => true;
